import { __assign } from '../../__helpers/tslib/tslib.es6.js';

/**
 * Get all object data except for the given keys
 *
 * @param   {object} object
 * @param   {array} keys
 * @returns {object}
 */
function objExcept(object, keys) {
    var newObject = __assign({}, object);
    for (var key in newObject) {
        if (keys.includes(key)) {
            delete newObject[key];
        }
    }
    return newObject;
}

export { objExcept as default };
